import { z } from "zod";

const envSchema = z.object({
  oidcAuthority: z.string(),
  oidcClientId: z.string(),
  appUrl: z.string(),
  appBasePath: z.string(), // brukes som /kundeportal eller /selskapsportal lokalt, mens er "/" i andre miljø
  appKundeportalUrl: z.string(),
  apiUrl: z.string(),
  isDebug: z.boolean(),
  mode: z.enum(["development", "production"]),
  // TODO: Fjern når passordbeskyttelse ikke er nødvendig lenger
  appPassword: z
    .string()
    .transform((val) => {
      if (val === "$(VITE_APP_PASSWORD)" || val.length === 0) {
        return undefined;
      }
      return val;
    })
    .optional(),
  sentryUrl: z.string().optional(),
  appInsightsConnectionString: z.string().optional(),
  featureMaaledataEnabled: z.boolean(),
  featureInnstillingerEnabled: z.boolean(),
});

const buildEnv = () => {
  const envVariables = {
    oidcAuthority:
      import.meta.env.VITE_OIDC_AUTHORITY || window.config.VITE_OIDC_AUTHORITY,
    oidcClientId:
      import.meta.env.VITE_OIDC_CLIENT_ID || window.config.VITE_OIDC_CLIENT_ID,
    appUrl:
      (import.meta.env.VITE_APP_URL || window.config.VITE_APP_URL) ??
      window.location.origin,
    appBasePath:
      (import.meta.env.VITE_APP_BASE_PATH ||
        window.config.VITE_APP_BASE_PATH) ??
      "/", // brukes som /kundeportal eller /selskapsportal lokalt, mens er "/" i andre miljø
    apiUrl: import.meta.env.VITE_API_URL || window.config?.VITE_API_URL,
    appKundeportalUrl:
      import.meta.env.VITE_APP_KUNDEPORTAL_URL ||
      window.config?.VITE_APP_KUNDEPORTAL_URL,
    appPassword:
      import.meta.env.VITE_APP_PASSWORD || window.config?.VITE_APP_PASSWORD,
    sentryUrl:
      import.meta.env.VITE_SENTRY_URL || window.config?.VITE_SENTRY_URL,
    appInsightsConnectionString:
      import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING ||
      window.config?.VITE_APPINSIGHTS_CONNECTION_STRING,
    isDebug:
      import.meta.env.VITE_IS_DEBUG === "true" ||
      window.config?.VITE_IS_DEBUG === "true",
    mode: import.meta.env.MODE || window.config.MODE,
    featureMaaledataEnabled:
      import.meta.env.VITE_FEATURE_MAALEDATA_ENABLED === "true" ||
      window.config.VITE_FEATURE_MAALEDATA_ENABLED === "true",
    featureInnstillingerEnabled:
      import.meta.env.VITE_FEATURE_INNSTILLINGER_ENABLED === "true" ||
      window.config.VITE_FEATURE_INNSTILLINGER_ENABLED === "true",
  };
  if (import.meta.env.VITE_SKIP_ENV_VALIDATION) {
    return envVariables;
  }
  return envSchema.parse(envVariables);
};

export const env = buildEnv();

export type ClientEnv = z.infer<typeof envSchema>;
